/* unplugin-vue-components disabled */import script from "./MarketPropsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPropsCard.vue?vue&type=script&setup=true&lang=js"

import "./MarketPropsCard.vue?vue&type=style&index=0&id=3e67add4&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e67add4"]])

export default __exports__